var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon6SuspendedcablecarWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_8",
    "data-name": "Layer 8",
    viewBox: "0.63 1.81 47.63 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #fff;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n\n      .cls-2 {\n        stroke-linecap: round;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.13333,50.81481H10.75556s-3.42223-3.6-3.42223-13.5,3.42223-13.5,3.42223-13.5H38.13333s3.42223,3.6,3.42223,13.5S38.13333,50.81481,38.13333,50.81481Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1.62963,
    y1: 14.81481,
    x2: 47.25926,
    y2: 2.81481
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 24.44444,
    y1: 23.81481,
    x2: 24.44444,
    y2: 39.81481
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 24.44444,
    y1: 8.81481,
    x2: 24.44444,
    y2: 19.81481
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.33333,
    y1: 39.81481,
    x2: 41.55556,
    y2: 39.81481
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "30.148 23.815 28.247 19.815 20.642 19.815 18.741 23.815"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6SuspendedcablecarWhite);
export default __webpack_public_path__ + "static/media/icon_6_suspendedcablecar_white.7038d91770937adee8496c67a2601c15.svg";
export { ForwardRef as ReactComponent };